"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropertyCardMLSLogo = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _Image = require("../Image/Image");
var _PropertyCardMLSLogo = require("./PropertyCardMLSLogo.styles");
var _excluded = ["attribution", "logoSrc"];
/**
 * Displays an MLS logo.
 *
 * @since 8.64.2
 */
var PropertyCardMLSLogo = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var attribution = _ref.attribution,
    logoSrc = _ref.logoSrc,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_PropertyCardMLSLogo.StyledPropertyCardMLSLogo, (0, _extends2.default)({
    ref: forwardedRef
  }, rest), /*#__PURE__*/_react.default.createElement(_Image.Image, {
    src: logoSrc,
    alt: attribution || '',
    "aria-hidden": true
  }));
});
exports.PropertyCardMLSLogo = PropertyCardMLSLogo;
PropertyCardMLSLogo.displayName = 'PropertyCard.MLSLogo';
PropertyCardMLSLogo.propTypes = {
  /**
   * The MLS attribution text. Used for alt text.
   *
   * Ex: alt="Listing provided by NWMLS"
   */
  attribution: _propTypes.default.string,
  /**
   * The URL for the MLS logo.
   */
  logoSrc: _propTypes.default.string
};